<template>
    <b-button
          block
          variant="transparent"
          size="lg"
          class="tw-py-3 tw-py-3 tw-z-[11] tw-border tw-border-gray-400 tw-rounded
            tw-shadow-lg tw-bg-white tw-mx-auto tw-w-[18.438rem] tw-max-w-full"
          @click="$emit('toggle')"
    >
        <i
              class="far mr-1"
              :class="{'fa-map': !renderMap, 'fa-th-large': renderMap}"
        />

        {{ renderMap ? 'List' : 'Map' }}
    </b-button>
</template>

<script>
    import "./PropertySearchContentListingModeToggle.scss";

    export default {
        name: "PropertySearchContentListingModeToggle",

        props: {
            renderMap: {
                type: Boolean,
                required: true,
            },
        },
    };
</script>
